'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildLatestMessage;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _MessageDescriptorSources = require('../../constants/MessageDescriptorSources');

var _buildPublishedMessage = require('../PubNubMessageFactory/buildPublishedMessage');

var _pubnubMessageSetters = require('../../pubnub-message/operators/pubnubMessageSetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Build a latest message record
 *
 * @param {Object|Map|PubNubMessageRecord} [props] - Properties to build the latest message from
 * @param {String} channel
 * @param {String} threadId
 * @return {PubNubMessageRecord|null}
 *
 */
function buildLatestMessage(props, channel, threadId) {
  if (!props) return null;
  return (0, _pipe2.default)(_buildPublishedMessage.buildPublishedMessage, (0, _pubnubMessageSetters.setChannel)(channel), (0, _pubnubMessageSetters.setThreadId)(threadId), (0, _pubnubMessageSetters.setSource)(_MessageDescriptorSources.CONVERSATION_OBJECT))(props);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/factories/ConversationFactory/buildLatestMessage.js
// module id = 877
// module chunks = 2 3